export default {
  data() {
    return {
      nextAnalyticsIndex: 0,
      analyticsMilestones: [0.0, 2.0, 5.0, 10.0, 20.0, 30.0, 40.0, 50.0, 60.0, 70.0, 80.0, 90.0, 100.0],
    };
  },
  methods: {
    $_pushAudioPlaybackEvent(audioId, offset) {
      while (offset >= this.analyticsMilestones[this.nextAnalyticsIndex]) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'audio_playback',
          'audioId': 'audioId ' + audioId,
          'audioMilestone': Math.trunc(this.analyticsMilestones[this.nextAnalyticsIndex]) + "%"
        });
        this.nextAnalyticsIndex += 1;
      }
    }
  }
};
